import { useContext } from 'react';
import { Grid, Button } from '@mui/material';
import { AddOutlined as AddIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';


let Filters = () => {

    return (
        <Grid container spacing={2} alignItems='center'>
            <Grid item xs />
            <Grid item>
                <Button
                    variant="contained"
                    color='inherit'
                    component={Link}
                    to={'/admin/referencedata/addnew'}
                >
                    <AddIcon />&nbsp;Add New
                </Button>
            </Grid>
        </Grid>
    );
}

export default Filters;